import { FC } from "react"
import { UserbotPage } from "./userbotPage"
import { ChainBuilder } from "../components"
import { useNavigate } from "react-router-dom"
import { launchResultPath } from "../components/common/launchResult"

export const ChainBuilderPage: FC = () => {
  const navigate = useNavigate()
  return (
    <UserbotPage title="Конструктор цепочки">
      <ChainBuilder
        mode="run"
        onLaunched={(result) => {
          const path = launchResultPath(result)
          if (path) navigate(path)
        }}
      />
    </UserbotPage>
  )
}
